module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-3.30822129.png";